import React from "react";
import styled from "styled-components";
// Components
import ProjectBox from "../Elements/ProjectBox";
import FullButton from "../Buttons/FullButton";
// Assets
import ProjectImg1 from "../../assets/img/projects/1.png";
import ProjectImg2 from "../../assets/img/projects/2.png";
import ProjectImg3 from "../../assets/img/projects/3.png";
import ProjectImg4 from "../../assets/img/projects/4.png";
import ProjectImg5 from "../../assets/img/projects/5.png";
import ProjectImg6 from "../../assets/img/projects/6.png";
import AddImage2 from "../../assets/img/add/add2.png";

export default function Projects() {
  return (
    <Wrapper id="projects">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Our Projects</h1>
            <p className="font13">
              We are constantly emerging and finding
              <br />
              New ways to encourage women in corporate world.
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={"https://img.freepik.com/free-vector/hands-holding-red-heart-love-care-family-protect-poster-vector-illustration_1284-2324.jpg?w=740&t=st=1662890216~exp=1662890816~hmac=e8d0ffbac2773b44a4dab27b07ae82590021db118b07423416958bd8aba70e0b"}
                title="She-Care"
                text="An initiative in which we help homeless females to live a beautiful life."
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={"https://img.freepik.com/free-vector/fingers-pointing-cartoon-businessman-spotlight-hand-holding-flashlight-best-employee-flat-vector-illustration-hr-choice-success-concept-banner-website-design-landing-web-page_74855-24129.jpg?w=740&t=st=1662890418~exp=1662891018~hmac=45cf3cf50a5bbb151bae2bffff29ebcd95bbe631eb5c5e3f272ceea7e60b22bd"}
                title="She-LimeLite"
                text="This is the initiative in which we help self-help-groups to reach new height."
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={"https://img.freepik.com/free-vector/illustration-light-bulb-icon_53876-43730.jpg?w=740&t=st=1662890308~exp=1662890908~hmac=c682a2deddb052acb133b8318bf3e6576fa44ea9a5c21dcc598e543a5893055b"}
                title="She-Ideathon"
                text="An event for college students to pitch their ideas in front of world and showcase their skills."
                action={() => alert("clicked")}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  padding: 100px 0;
  margin: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 60px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  position: relative;
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
  }
`;
const AddLeftInner = styled.div`
  width: 100%;
  position: absolute;
  top: -300px;
  left: 0;
  @media (max-width: 1190px) {
    top: -250px;
  }
  @media (max-width: 920px) {
    top: -200px;
  }
  @media (max-width: 860px) {
    order: 1;
    position: relative;
    top: -60px;
    left: 0;
  }
`;
const ImgWrapper = styled.div`
  width: 100%;
  padding: 0 15%;
  img {
    width: 100%;
    height: auto;
  }
  @media (max-width: 400px) {
    padding: 0;
  }
`;
